<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.09 7.5a1 1 0 00-1 1v3a5 5 0 01-10 0v-3a1 1 0 00-2 0v3a7 7 0 006 6.92V20h-2a1 1 0 000 2h6a1 1 0 100-2h-2v-1.58a7 7 0 006-6.92v-3a1 1 0 00-1-1z"/><path d="M12.09 15a3.5 3.5 0 003.5-3.5v-6a3.5 3.5 0 00-7 0v6a3.5 3.5 0 003.5 3.5zm-1.5-9.5a1.5 1.5 0 013 0v6a1.5 1.5 0 01-3 0z"/></svg>